import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ecm-mat-visitor-home-multiple-entry',
    templateUrl: 'material-visitor-home-multiple-entry.html',
    styleUrls: ['material-visitor-home-multiple-entry.css'],
    standalone: true,
    imports: [],
})
export class MaterialVisitorHomeMultipleEntryComponent implements OnInit {
    @Input() public e2e?: string;
    @Input() public entryPoints = [];
    @Input() public multiplePossibilitiesLabel: string;
    @Output() public loginEventEmitter = new EventEmitter();

    /**
     * @inheritDoc
     */
    public ngOnInit(): void {
        // set e2e data tag
        this.e2e = this.e2e || 'e2e-material-visitor-home-accordion-modulo';
    }

    public emitLoginEvent(entryPoint) {
        this.loginEventEmitter.emit(entryPoint.id);
    }
}
